import GoogleMaterialIcon from '@/components/icons/google-material-icon/google-material-icon';
import { taxonomyAPI } from '@/providers/apis/taxonomy/taxonomy';
import { Vue, Component, Watch, Prop } from 'vue-property-decorator';

@Component({
    name: 'mastery-content-completion',
    components: {
        'material-icons': GoogleMaterialIcon,
    },
})

export default class MasteryContentCompletion extends Vue {

    // --------------------------------------------------------------------
    // Properties

    @Prop()
    private categorySubjectData: any;

    @Prop({ default: {} })
    private value: any;

    @Prop()
    private isReadOnly: any;

    private dataPropsValues: any = [];

    private content: any = {};

    private isExpand: boolean = false;

    private indexNumber: number = 5;

    private cateogryOptions: any = [];

    private subjectAndFwList: any = [];

    private selectedRecentItem: any = {};

    private isLoading: any = false;

    @Watch('categorySubjectData')
    private onWatchData(data: any) {
        if (data && data.length > 0) {
            this.fetchDisplayPropParent();
        }
    }
    // ---------------------------------------------------------------------
    // Methods

    private created() {
        this.content = this.value;
        if (!this.isReadOnly) {
            this.fetchCategoryList();
            // this.fetchDisplayProp();
        }

    }

    private mounted() {
        if (this.categorySubjectData && this.categorySubjectData.length > 0) {
            this.fetchDisplayPropParent();
        }
    }

    private async fetchDisplayPropParent() {
        const valueData: any = this.content;
        const dataValuesCalculate: any = [];
        const categoryList = this.categorySubjectData;
        for (const prop in valueData) {
            if (valueData.hasOwnProperty(prop)) {
                const propSplit = prop.split('.');
                const data: any = {
                    keyName: prop,
                    keyValue: valueData[prop],
                    categoryId: propSplit[1],
                    subjectId: `${propSplit[1]}.${propSplit[2]}`,
                    frameworkId: propSplit[0],
                };
                dataValuesCalculate.push(data);
            }
        }
        for await (const [index, iterator] of dataValuesCalculate.entries()) {
            const selectedCategoryIndex = categoryList.findIndex((catItem: any) => {
                return catItem.code === iterator.categoryId;
            });
            if (selectedCategoryIndex !== -1) {
                const selectedSubjectIndex = categoryList[selectedCategoryIndex].subjectList.findIndex((item: any) => {
                    return item.id === iterator.subjectId;
                });
                const selectedSubject = categoryList[selectedCategoryIndex].subjectList[selectedSubjectIndex];
                iterator.subjectTitle = selectedSubject.title;
            }
        }
        this.dataPropsValues = dataValuesCalculate;
    }

    private getSubjectList(categoryId: string) {
        return taxonomyAPI.fetchSubjects(categoryId).then((subjectList: any) => {
            return subjectList;
        });
    }

    private showMore() {
        this.indexNumber = this.indexNumber + 5;
        this.$emit('showMore');
    }

    private adjustHeight() {
        this.$emit('showMore');
    }

    private fetchCategoryList() {
        const valueData: any = this.content;
        const dataValuesCalculate: any = [];
        for (const prop in valueData) {
            if (valueData.hasOwnProperty(prop)) {
                const propSplit = prop.split('.');
                const data: any = {
                    keyName: prop,
                    keyValue: valueData[prop],
                    categoryId: propSplit[1],
                    subjectId: `${propSplit[1]}.${propSplit[2]}`,
                    frameworkId: propSplit[0],
                };
                dataValuesCalculate.push(data);
            }
        }
        this.isLoading = true;
        taxonomyAPI.fetchTaxonomyClassifications().then(async (categoryList: any) => {
            for await (const [index, iterator] of categoryList.entries()) {
                const catIndex = dataValuesCalculate.findIndex((item: any) => {
                    return item.categoryId === iterator.code;
                });
                const subjectList = await taxonomyAPI.fetchSubjects(iterator.id);
                if (catIndex !== -1) {
                    iterator.preSelect = true;
                    subjectList.filter((subject: any) => dataValuesCalculate.
                        findIndex((dataValue: any) => dataValue.subjectId === subject.id) >= 0)
                        .forEach((selectedNewSubject: any) => {
                            selectedNewSubject.preSelect = true;
                            selectedNewSubject.frameworks.filter((fw: any) => dataValuesCalculate.
                                findIndex((dataValue: any) => dataValue.keyName === fw.taxonomy_subject_id) >= 0)
                                .forEach((selectedNewFW: any) => {
                                    selectedNewFW.value = valueData[selectedNewFW.taxonomy_subject_id];
                                });
                        });
                }
                iterator.subjects = subjectList;
                if (index >= categoryList.length - 1) {
                    this.isLoading = false;
                    this.selectedRecentItem = categoryList[0];
                    this.subjectAndFwList = this.selectedRecentItem.subjects;
                    this.cateogryOptions = categoryList;
                }
            }
        });
    }

    private selectCategroy(item: any) {
        this.selectedRecentItem = item;
        this.subjectAndFwList = item.subjects;
    }

    private onUpdateFw(itemFw: any) {
        const item = itemFw.taxonomy_subject_id;
        itemFw.value = typeof (itemFw.value) === 'string' ? parseInt(itemFw.value, 10) : itemFw.value;
        this.value[item] = {
            framework: itemFw.standard_framework_id,
            percent_completion: itemFw.value,
        };
        this.$emit('input', this.value);
    }

}
